import * as i0 from '@angular/core';
import { input, Component, HostListener, Directive } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BREAKPOINT_VALUES } from '@futura/futura-ui/breakpoint';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1 from '@angular/cdk/overlay';
const _c0 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function TooltipComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TooltipComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, TooltipComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.type());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c0, ctx_r0.text(), ctx_r0.index()));
  }
}
function TooltipComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.type())("innerHTML", ctx_r0.text(), i0.ɵɵsanitizeHtml);
  }
}
let TooltipComponent = /*#__PURE__*/(() => {
  class TooltipComponent {
    constructor() {
      this.text = input();
      this.template = input();
      this.index = input();
      this.type = input('default');
      this.leaveFunction = input();
    }
    onMouseLeave() {
      let leaveFunction = this.leaveFunction();
      if (!leaveFunction) {
        return;
      }
      leaveFunction();
    }
    static {
      this.ɵfac = function TooltipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TooltipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TooltipComponent,
        selectors: [["fut-tooltip"]],
        hostBindings: function TooltipComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseleave", function TooltipComponent_mouseleave_HostBindingHandler() {
              return ctx.onMouseLeave();
            });
          }
        },
        inputs: {
          text: [1, "text"],
          template: [1, "template"],
          index: [1, "index"],
          type: [1, "type"],
          leaveFunction: [1, "leaveFunction"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [[1, "tooltip-container", 3, "ngClass"], [1, "tooltip-container", 3, "ngClass", "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function TooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, TooltipComponent_Conditional_1_Template, 2, 6, "div", 0)(2, TooltipComponent_Conditional_2_Template, 1, 2, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_0_0 = ctx.template()) ? 1 : 2, tmp_0_0);
          }
        },
        dependencies: [NgClass, NgTemplateOutlet],
        styles: [".tooltip-container[_ngcontent-%COMP%]{border-radius:.29em;background-color:var(--fut-primary-300);color:#fff;padding:.43em 1.14em}.tooltip-container.secondary[_ngcontent-%COMP%]{background-color:var(--fut-secondary-800)}"]
      });
    }
  }
  return TooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isString(tooltip) {
  return typeof tooltip === 'string';
}
let TooltipDirective = /*#__PURE__*/(() => {
  class TooltipDirective {
    constructor(overlay, overlayPositionBuilder, elementRef) {
      this.overlay = overlay;
      this.overlayPositionBuilder = overlayPositionBuilder;
      this.elementRef = elementRef;
      this.futTooltip = input();
      this.hideTooltip = input(false);
      this.position = input('top');
      this.tooltipType = input('default');
    }
    ngOnDestroy() {
      this.closeToolTip();
    }
    onMouseenter() {
      // disable tooltip in small devices
      if (window.innerWidth <= BREAKPOINT_VALUES.md) {
        return;
      }
      let appFutTooltip = this.futTooltip();
      if (!this.hideTooltip() && appFutTooltip && !this.overlayRef?.hasAttached()) {
        const positionStrategy = this.createPositionStrategy();
        this.overlayRef = this.overlay.create({
          positionStrategy
        });
        this.tooltipRef = this.overlayRef.attach(new ComponentPortal(TooltipComponent));
        if (isString(appFutTooltip)) {
          this.tooltipRef.setInput('text', appFutTooltip);
        } else {
          this.tooltipRef.setInput('template', appFutTooltip);
        }
        this.tooltipRef.setInput('type', this.tooltipType());
        this.tooltipRef.setInput('leaveFunction', () => this.closeToolTip());
      }
    }
    onMouseleave() {
      if (!this.overlayRef?.hasAttached() || this.hideTooltip()) {
        return;
      }
      this.closeToolTip();
    }
    createPositionStrategy() {
      const {
        originX,
        overlayX,
        originY,
        overlayY,
        offsetX,
        offsetY
      } = this.calculatePosition();
      return this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withPositions([{
        originX,
        originY,
        overlayX,
        overlayY,
        offsetX,
        offsetY
      }]);
    }
    calculatePosition() {
      let originX = 'center';
      let overlayX = 'center';
      let originY = 'center';
      let overlayY = 'center';
      let offsetY = 0;
      let offsetX = 0;
      let position = this.position();
      if (position === 'top' || position === 'bottom') {
        overlayY = 'bottom';
        originY = position;
        offsetY = -5;
        if (position === 'bottom') {
          overlayY = 'top';
          offsetY = 5;
        }
      }
      if (position === 'start' || position === 'end') {
        overlayX = 'end';
        originX = position;
        offsetX = -5;
        if (position === 'end') {
          overlayX = 'start';
          offsetX = 5;
        }
      }
      return {
        originX,
        overlayX,
        originY,
        overlayY,
        offsetX,
        offsetY
      };
    }
    closeToolTip() {
      if (this.overlayRef && this.overlayRef?.hasAttached()) {
        this.overlayRef.detach();
        this.overlayRef.dispose();
        this.overlayRef = undefined;
      }
    }
    static {
      this.ɵfac = function TooltipDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TooltipDirective)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i1.OverlayPositionBuilder), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TooltipDirective,
        selectors: [["", "futTooltip", ""]],
        hostBindings: function TooltipDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseenter", function TooltipDirective_mouseenter_HostBindingHandler() {
              return ctx.onMouseenter();
            })("mouseleave", function TooltipDirective_mouseleave_HostBindingHandler($event) {
              return ctx.onMouseleave($event);
            });
          }
        },
        inputs: {
          futTooltip: [1, "futTooltip"],
          hideTooltip: [1, "hideTooltip"],
          position: [1, "position"],
          tooltipType: [1, "tooltipType"]
        },
        standalone: true
      });
    }
  }
  return TooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipComponent, TooltipDirective };
